// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order.intrastatReports', {
        url: '/intrastatreports',
        templateUrl: 'main/order/reports/intrastatReports.tpl.html',
        controller: 'IntrastatReportsController as vm',
        resolve: {
        }
    });
}

// @ngInject
function IntrastatReportsController($translate, Rms2ReportsApiService, ToasterService, loadSpinnerService) {
    var vm = this;

    //Variables
    vm.fromDate = new Date();
    vm.fromDate.setDate(vm.fromDate.getDate() - 1);
    vm.toDate = new Date();

    //Methods
    vm.getIntrastatReport = getIntrastatReport;

    function getIntrastatReport() {
        var request = {
            fromDate : vm.fromDate,
            toDate : vm.toDate
        }

        loadSpinnerService.start("mainSpinner");
        Rms2ReportsApiService.getIntrastatReport(request).then(function(response) {
            console.log(response.data);
            ToasterService.showSuccess("SUCCESS");
        }, function(error) {
            console.log(error);
            ToasterService.showError(error, $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop("mainSpinner");
        });
    }
}

angular.module('order.intrastatReports', [])
    .config(stateConfig)
    .controller('IntrastatReportsController', IntrastatReportsController);
